import React, { useCallback, useReducer, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Styles from './index.module.scss';
import {
	Input,
	RadioGroup,
	Radio,
	DateRangePicker,
	Button,
	Select,
	MultiSelect,
	Slider,
	Spinner,
	Toast,
	Alerts,
	Tooltip,
	Chip,
} from '@kaleyra/emmy';
import FilterIcon from '../../../../../../../assets/filter.svg';
import { isArray, isEmpty } from 'lodash';
import { messageType, IRequestReport, RequestReportFieldName } from '../../../../../../../interface/whatsappReport';
import cn from 'classnames';
import moment from 'moment';


type RequestReportPropType = {
	getOptions: any;
}

type OptionType = {
	label: string;
	value: string;
};

export type MapStateType = {
	data: any;
	requestReport: IRequestReport;
};

export type DispatchPropsType = {
	onClose: () => void;
	onChange: (fields: { name: RequestReportFieldName; value: string }) => void;
	onSave: (applyTemplateData: any, callback: (resp: any, flag: boolean) => void) => void;
	onLoad: () => void;
	onLoadData: () => void;
	setRequestReportState: (tempObj: IRequestReport) => void;
};



interface FilterState {
	"status": string,
	"msg_type": messageType[]
}

const initialState: FilterState = {
	"status": '',
	"msg_type": []
}

type FilterKeyType =
	| "status"
	| "msg_type"

const stateReducer = (state: FilterState, newState: Partial<FilterState>) => ({ ...state, ...newState })

const getObjectKey = <U extends keyof T, T extends object>(key: U) => (obj: T) => obj[key];

const RequestReportTemplate: React.FC<RequestReportPropType & DispatchPropsType & MapStateType> = ({
	requestReport,
	onClose,
	onSave,
	onLoad,
	data,
	onLoadData,
	onChange,
	setRequestReportState
}) => {
	const { t } = useTranslation();
	const [filterVisible, setFilterVisible] = useState(false);
	const [requestInprogress, SetRequestInprogress] = useState(false);
	const [filterState, setFilter] = useReducer(stateReducer, initialState);
	const { whatsappReportData } = data;
	const [dateRange, setDateRange] = useState<any>([]);

	const handleFilterVisibility = () => {
		setFilterVisible(!filterVisible);
	};

	const handleRequestInprogress = () => {
		SetRequestInprogress(!requestInprogress);
	}

	const onCancelFilter = () => {
		setFilter({
			"status": requestReport?.status || "",
			"msg_type": requestReport?.msg_type || []
		})
		handleFilterVisibility()
	}

	const onApplyFilter = () => {
		setRequestReportState({ ...requestReport, ...filterState })
		handleFilterVisibility()
	}

	const STATUS_LABEL: Record<string, string> = {
		"delivered": t('overviewWidgetWhatsAppDelivered'),
		"seen": t('BLD01588'),
		"sent": t('BLD01515'),
		"failed": t('mainFailed'),
	}

	const FORMAT_LABEL: Record<string, string> = {
		"template": t('mainTemplate'),
		"text": t('BLD01578'),
		"media": t('BLD01579'),
		"mediatemplate": t('BLD01589')
	}

	const RequestKeyName: Record<string, string> = {
		"numbers": t("BLD00543"),
		"report_name": t("BLD01606"),
		"report_type": t("BLD01605"),
		"Date Range": t("KLR0035"),
		"Start_Date": t("startDate"),
		"End_Date": t("endDate"),
		"status": t("mainStatus"),
		"msg_type": t("messageType")
	}

	const getOptions = (key: string): OptionType[] => {
		let options: OptionType[] = [];
		let keyOptions: Record<string, any>;
		switch (key) {
			case 'status':
				keyOptions = { ...STATUS_LABEL };
				break;
			case 'numbers':
				keyOptions = whatsappReportData?.data?.numbers ? { ...whatsappReportData.data.numbers } : {};
				break;
			case 'format':
				keyOptions = { ...FORMAT_LABEL };
				break;
			default:
				keyOptions = {};
				break;
		}
		Object.keys(keyOptions).forEach((key: string) => {
			options.push({
				label: keyOptions[key],
				value: key
			})
		})


		return options;

	}

	const getLabel = (state: string, key: string) => {
		let label: string;
		switch (state) {
			case 'status':
				label = STATUS_LABEL[key];
				break;
			case 'numbers':
				label = whatsappReportData?.data?.numbers ? whatsappReportData.data.numbers[key] : {};
				break;
			case 'msg_type':
				label = FORMAT_LABEL[key];
				break;
			default:
				label = "-";
				break;
		}
		return label;
	}

	// const resetFilter = () => {
	// 	setFilter({
	// 		"status": "",
	// 		"msg_type": []
	// 	})
	// }

	const callback = (response: any, flag: boolean) => {
		handleRequestInprogress();
		if (flag && response.data && isEmpty(response.error)) {
			Toast(response.message, 'success');
			onClose();
			onLoad();
			if (!isEmpty(data.smsReportData) && data.smsReportData.data.length === 0) {
				onLoadData();
			}
		} else if (!isEmpty(response.error)) {
			Object.keys(response.error).forEach((key: any) => {
				Toast(response.error[key], 'error');
			});
		} else {
			Toast(response.message, 'error');
		}
	}

	const onRequestReportSave = () => {
		const { numbers, report_name, report_type, date_range, Start_Date, End_Date, status, msg_type } = requestReport;
		if (!numbers || numbers === '') {
			Toast(t("BLD01591"), "error");
			return;
		}
		if (!report_name || report_name === '') {
			Toast(t("BLD01535"), "error");
			return;
		}
		if (!report_type || report_type === '') {
			Toast(t("BLD01536"), "error");
			return;
		}

		if (!Start_Date || Start_Date === '') {
			Toast(t("BLD01537"), "error");
			return;
		}
		if (!End_Date || End_Date === '') {
			Toast(t("BLD01538"), "error");
			return;
		}

		let saveDataOb: any = {
			"numbers": numbers,
			"report_name": report_name,
			"report_type": report_type,
			"Date Range": date_range,
			"Start_Date": Start_Date,
			"End_Date": End_Date,
			"status": status,
			"msg_type": msg_type
		}

		var formData = new FormData();
		for (var key in saveDataOb) {
			if (Array.isArray(saveDataOb[key]) ? saveDataOb[key].length : saveDataOb[key])
				formData.append(key, saveDataOb[key]);
		}
		handleRequestInprogress();
		onSave(formData, callback);
	}

	const onFilterChange = (
		name: RequestReportFieldName,
		isCustom: boolean = false
	) => (value: any) => {
		setFilter({
			[name]: isCustom
				? (value as React.ChangeEvent<
					HTMLInputElement | HTMLTextAreaElement
				>).target.value
				: value,
		});
	};

	const onLocalChange = (
		name: RequestReportFieldName,
		isCustom: boolean = false
	) => (value: any) => {
		onChange({
			name,
			value: isCustom
				? (value as React.ChangeEvent<
					HTMLInputElement | HTMLTextAreaElement
				>).target.value
				: value,
		});
	};

	const onDateChange = (value: any) => {
		if (!isArray(value)) {
			setDateRange(value);
			setRequestReportState({ ...requestReport, Start_Date: '', End_Date: '' });
			;
		} else {
			let [startDate, endDate] = value;
			if (startDate && endDate) {
				setDateRange(value);
				startDate = startDate.format('DD/MMM/YYYY');
				endDate = endDate.format('DD/MMM/YYYY');
				setRequestReportState({ ...requestReport, Start_Date: startDate, End_Date: endDate });
			}
		}
	};

	const getFilterCount = useCallback((): number => {
		let count = 0
		Object.keys(filterState).forEach((key: any) => {
			let value = getObjectKey<keyof FilterState, FilterState>(key)(filterState);
			if (Array.isArray(value)) {
				count += value.length
			}
			else if (value) {
				count++
			}
		});

		return count;

	}, [filterState])

	const onRemoveFilter = (key: FilterKeyType) => {
		delete filterState[key];
		delete requestReport[key];
		setFilter({ ...filterState })
		setRequestReportState({ ...requestReport, ...filterState })
	}

	const getFilterTags = useCallback((): React.ReactNode[] => {
		let tags: React.ReactNode[] = []
		Object.keys(filterState).forEach((key: any) => {
			let value = getObjectKey<keyof FilterState, FilterState>(key)(filterState);
			if (Array.isArray(value) && value.length) {
				tags.push(
					<Tooltip
						placement="bottom"
						title={value.map(item => getLabel(key, item)).join(", ")}
						trigger={['hover', 'click']}
					>
						<span>
							<Chip
								closable
								label={`${RequestKeyName[key]}-${value.length}`}
								chipStyle={{
									display: "inline-flex",
									marginTop: '0.5rem',
									marginRight: '0.5rem',
								}}
								onClose={() => onRemoveFilter(key)}
							/>
						</span>
					</Tooltip>)
			}
			else if (!Array.isArray(value) && value) {
				return tags.push(<Chip
					closable
					label={`${RequestKeyName[key]}-${getLabel(key, value)}`}
					chipStyle={{
						display: "inline-flex",
						marginTop: '0.5rem',
						marginRight: '0.5rem',
					}}
					onClose={() => onRemoveFilter(key)}
				/>)
			}
		});

		return tags;

	}, [filterState])

	const footer = (): React.ReactNode => {
		return (
			filterVisible ? (<div className={Styles.footerContainer}>
				<Button type="tertiary" onClick={onCancelFilter}>
					{t('mainCancel')}
				</Button>
				<Button type="primary" onClick={onApplyFilter}>
					{t('apply')}
				</Button>
			</div>) :
				(<div className={Styles.footerContainer}>
					<Button type="tertiary" onClick={onClose}>
						{t('mainCancel')}
					</Button>
					<Button type="primary" disabled={requestInprogress} onClick={onRequestReportSave}>
						{requestInprogress ? <Spinner /> : t('mainSave')}
					</Button>
				</div>)
		);
	};

	const renderFilter = () => {

		// Input fields to be replaced with multi select options
		return (
			<div className={Styles.formWrapper}>
				<div className={Styles.fieldContainer}>
					<Select
						placeholder={t('statusPlaceholder')}
						label={t('statusPlaceholder')}
						selectClassName={Styles.selectBox}
						className={Styles.selectBox}
						value={filterState?.status ? filterState?.status : undefined}
						options={getOptions('status')}
						onChange={onFilterChange('status')}
					></Select>
				</div>
				<div className={Styles.fieldContainer}>
					<MultiSelect
						placeholder={t('messageType')}
						selectClassName={Styles.selectBox}
						className={Styles.selectBox}
						options={getOptions('format')}
						value={filterState?.msg_type}
						onChange={onFilterChange('msg_type')}
					></MultiSelect>
				</div>
			</div>
		);
	};

	const renderRequestFormBody = () => {
		const filterCount = getFilterCount();
		return (
			<div className={Styles.formWrapper}>
				<div className={cn(Styles.alert, Styles.alertText)}>
					<Alerts
						customImage={<></>}
						content={t('KLR0034')}
						type="draft"
					>
					</Alerts>
				</div>
				<div className={Styles.fieldContainer}>
					<Select
						label={t('BLD01592')}
						placeholder={t('BLD01592')}
						value={requestReport?.numbers}
						options={getOptions('numbers')}
						onChange={onLocalChange('numbers')}
					>
					</Select>
				</div>
				<div className={Styles.fieldContainer}>
					<Input
						placeholder={t('mainTitle')}
						value={requestReport?.report_name}
						onChange={onLocalChange('report_name', true)}
						style={{ height: '3rem' }}
					/>
				</div>
				<div className={Styles.reportTypeContainer}>
					<p className={Styles.secondaryTextStyle} style={{ marginBottom: "0.7rem" }}>{t("typeOfReport")}</p>
					<RadioGroup
						className={Styles.radioGroupContainer}
						value={requestReport?.report_type}
						onChange={onLocalChange('report_type', true)}
						name={'reportType'}
					>
						<Radio name={'reportType'} style={{ marginRight: "6rem" }} value={'summary'}>
							<span className={Styles.radioOptionStyle}>
								{t('summary')}
							</span>
						</Radio>
						<Radio name={'reportType'} value={'tabular'}>
							<span className={Styles.radioOptionStyle}>
								{t('detailed')}
							</span>
						</Radio>
					</RadioGroup>
				</div>
				<DateRangePicker
					placeholder={[t('startDate'), t('endDate')]}
					onOk={onDateChange}
					value={dateRange}
					formatForDatePicker={'DD MMM YYYY'}
					style={{ width: '100%', marginTop: '0.25rem' }}
					disabledDate={(current: any) => {
						return current && current > moment().endOf('day');
					}}
					onClear={onDateChange}
					dropdownClassName="m-0"
				/>
				<div className='d-flex justify-content-between'>
					<div>
						<p className={cn(Styles.primaryTextStyle)} style={{ margin: "0" }}>{t('Filters')}</p>
						<p className={Styles.secondaryTextStyle} style={{ margin: "0" }}>
							{t('setFilter')}
						</p>
					</div>
					{filterCount ? <div>
						<Button
							type={'secondary'}
							iconPosition={'right'}
							className={"d-flex-right"}
							onClick={handleFilterVisibility}
							small
						>
							Edit
						</Button>
					</div> : null}
				</div>
				{
					filterCount ?
						<div className={Styles.filterTagContainer}>
							{getFilterTags()}
						</div>
						: <div className={Styles.filterButtonContainer}>
							<Button
								type={'secondary'}
								icon={<img src={FilterIcon} alt="filter"/>}
								iconPosition={'right'}
								onClick={handleFilterVisibility}
								small
							>
								{'Add Filter'}
							</Button>
						</div>
				}


			</div>
		);
	};

	return (
		<>
			<Slider
				onClose={onClose}
				title={t('requestReport')}
				containerId={'root-modal'}
				footer={footer()}
				visibility={true}
			>
				{!filterVisible && renderRequestFormBody()}
				{filterVisible && renderFilter()}
			</Slider>
		</>
	);
};

export default RequestReportTemplate;
